import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { tap, shareReplay } from 'rxjs/operators';
import { 
	Integration, 
	IntegrationStatus,
	IntegrationHighLevelStatus
 } from '../interfaces/integrations';
import{ IntegrationStatusType } from '../constants/statusType.enum';
import { Account } from '@mitel/cloudlink-sdk';
import { AccountsService } from './accounts.service';
import { IntegrationsService } from './integrations.service';
import { GWPIntegrationService } from './gwp-integration.service';
import { Util } from 'src/app/core/utils/Util';

@Injectable({
	providedIn: 'root'
})

export class AccountIntegStatusService 
{

	accountIntegrationStatusObservable:  { [accountId: string]: Observable<IntegrationStatus[]> } = {};
	combinedIntegs: Integration[] = [];
	completedIntegrationStatuses: { [accountId: string]: any[] } = { };
	haltStatusUpdate:Subject<boolean> = new Subject();
	active: boolean = true;
	constructor(private accountsService: AccountsService,
				private integService: IntegrationsService,
				private gwpIntegrationService: GWPIntegrationService) 
	{
		this.combinedIntegs = this.integService.getMitelIntegrationList({} as any);
		this.combinedIntegs.concat( this.integService.getThirdPartyIntegrationList({} as any) );

	}

	addCompletedStatus(accountId, status) {
		this.completedIntegrationStatuses[accountId] = status;
	}

	getAccountIntegrationStatus( account: Account, activeOnly: boolean ): Observable<IntegrationStatus[]>
	{
	//	console.log("Requesting STATUS for Account ", account);
		this.accountIntegrationStatusObservable[account.accountId] =  Observable.create( async (observer) => {

			var acctStatusObjs : IntegrationStatus[] = [];

			var tags = undefined;
			if (this.active && account.active == true && activeOnly == true) { // we do not determine the status of deactivated accounts
				tags = account.tags;
			}

	//		console.log("Got the account tags", account.accountId, tags )
			if ( tags && tags.products )
			{
				for ( var j = 0; j < tags.products.length; j++ ) 
				{
					let elem = tags.products[j];
					if ( this.integService.isAnAccountBasedIntegration(elem) === true )
					{
						// we do not care about the integration unless it is one the accounts app knows about
						// create a status object for the integration
						var prodDesc = this.combinedIntegs.find( integ => {
							return integ.productCode == elem;
						});

						var canBeSelected = true;
						if (prodDesc && prodDesc.service && prodDesc.service.canBeSelected && prodDesc.service.getHighLevelStatus && this.active) {
							// if a service does not have a status to display, no need to check if it can be selected
							// eliminates unnecessary server calls!
							canBeSelected = await prodDesc.service.canBeSelected(account);
						}

						if (prodDesc && canBeSelected) // this should not happen except in a developer workspace
						{
							var integStatusObj: IntegrationStatus = {
								productCode: elem,
								integNameStatusDisplayString: prodDesc.displayName, 
								status: undefined
							}
							if ( prodDesc.service && prodDesc.service.getHighLevelStatus && this.active ) // if the integration has no service, assume all is OK!
							{
								var statusInfo = await prodDesc.service.getHighLevelStatus(account, this.haltStatusUpdate, tags);
								integStatusObj.status = statusInfo;
							}
							else
							{
								// a status of unknown is returned
								var unknownStatus: IntegrationHighLevelStatus = {
									state: IntegrationStatusType.UNKNOWN,
									statusDisplayString: undefined
								};
								integStatusObj.status = unknownStatus;
							}
		
							acctStatusObjs.push(integStatusObj);
						}
					}
				}
			}
			observer.next( acctStatusObjs );
		}).
		pipe(
			tap(() => { console.log('getAccountIntegrationStatus() TAP method executed')}),
			shareReplay(1)
		);
		return  this.accountIntegrationStatusObservable[account.accountId];
	}

	stopAndClearAllStatus()
	{
		this.active = false;
		this.haltStatusUpdate.next(true);
		this.accountIntegrationStatusObservable = {};
	}

	allowStatusUpdates() {
		this.active = true;
		this.haltStatusUpdate.next(false);
	}
	
}
